// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_etp.ml",
      77,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "Etp"
                    ]]
                },
                "V1alpha1"
              ]]
          },
          "Control"
        ]]
    });

const Control = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_etp.ml",
      119,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "Etp"
              ]]
          },
          "V1alpha1"
        ]]
    });

const V1alpha1 = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_etp.ml",
      159,
      10
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "Etp"
        ]]
    });

const Etp = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_etp.ml",
      192,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.control.v1alpha1.Etp";
}

function make(idOpt, keyOpt, nameOpt, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  const key = keyOpt !== undefined ? keyOpt : "";
  const name = nameOpt !== undefined ? nameOpt : "";
  return {
          id: id,
          key: key,
          name: name
        };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_key = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "key",
            "key"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "name",
            "name"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge(t1, t2) {
  return {
          id: Curry._2(merge_id, t1.id, t2.id),
          key: Curry._2(merge_key, t1.key, t2.key),
          name: Curry._2(merge_name, t1.name, t2.name)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.int32_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "key",
                        "key"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "name",
                            "name"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._4(serialize, writer, param.id, param.key, param.name);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(id, key, name) {
  return {
          id: id,
          key: key,
          name: name
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.Etp", spec(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.id, param.key, param.name);
  };
}

function constructor$1(id, key, name) {
  return {
          id: id,
          key: key,
          name: name
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.Etp", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, Etp, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "Etp"
        ]]
    }, V1alpha1, {
      Etp: Etp
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "Etp"
              ]]
          },
          "V1alpha1"
        ]]
    }, Control, {
      V1alpha1: V1alpha1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "Etp"
                    ]]
                },
                "V1alpha1"
              ]]
          },
          "Control"
        ]]
    }, Buhta, {
      Control: Control
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
